const filters = {};

export default filters;
